import { odata } from '../../conf';
import Actions from '../../odata/actions';
import { useAuth } from '../../../use';

const auth = useAuth();

const actions = new Actions('jobListingTask', 'jobListingTasks');

const customActions = {
  async LOAD_JobListingTasksByJobListingId({ commit, rootGetters }, jobListingId) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('jobListingTasks')
      .query({ $filter: `IsDeleted eq false AND JobListingId eq ${jobListingId}` });
    commit('SET_jobListingTasks', data);
    return data;
  },
};

export default { ...actions, ...customActions };
